<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  <div i18n="@@cardInfo">Card Info</div>
  <mat-icon (click)="closeDialog()" class="cursor" i18n-aria-label="@@closeDialog" aria-label="Close">close</mat-icon>
</div>

<mat-dialog-content>
  <form #checkout="ngForm" (ngSubmit)="onSubmit(checkout)" class="checkout">
    <div class="form-row">
      <div id="card-info" #cardInfo></div>

      @if (error) {
        <div id="card-errors" role="alert" i18n="@@cardErrorMessage">{{ error }}</div>
      }
    </div>

    <button type="submit" data-testid="card_billing_button" class="w-100"  mat-raised-button color="accent" i18n="@@payButton">Pay</button>
  </form>
</mat-dialog-content>